import google from "./google-ads.png";
import facebook from "./facebook.png";
import linkedin from "./linkedin.png";
import tiktok from "./tiktok.png";
import twitter from "./twitter.png";
import mailchimp from "./mailchimp.png";
import microsoft from "./microsoft.png";
import emailCampaign from "../email-campaign.svg";
import x from './x.png'

const images = {
    google,
    facebook,
    linkedin,
    tiktok,
    twitter,
    mailchimp,
    microsoft,
    emailCampaign,
    x
}
export default images;
